/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface ParticipantLink
 */
export interface ParticipantLink {
    /**
     * 
     */
    url: string;
    /**
     * 
     */
    expires_at: Date;
}

/**
 * Check if a given object implements the ParticipantLink interface.
 */
export function instanceOfParticipantLink(value: object): value is ParticipantLink {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('expires_at' in value) || value['expires_at'] === undefined) return false;
    return true;
}

export function ParticipantLinkFromJSON(json: any): ParticipantLink {
    return ParticipantLinkFromJSONTyped(json, false);
}

export function ParticipantLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantLink {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'expires_at': (json['expires_at'] == null ? json['expires_at'] : parseDateTime(json['expires_at'])),
    };
}

export function ParticipantLinkToJSON(json: any): ParticipantLink {
    return ParticipantLinkToJSONTyped(json, false);
}

export function ParticipantLinkToJSONTyped(value?: ParticipantLink | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'expires_at': value['expires_at'] == null ? value['expires_at'] : serializeDateTime(value['expires_at']),
    };
}

